import { useEffect } from "react";
import { useAuth0 } from "@auth0/auth0-react";
import { Outlet, useLocation } from "react-router-dom";
import LoadingScreen from "../components/progress/loading-screen";
import ComplianceGate from "../components/compliance/compliance-gate";
import config from "../config";

const SecureRoute = () => {
  const { isAuthenticated, isLoading, loginWithRedirect, user } = useAuth0();
  const location = useLocation();

  useEffect(() => {
    if (!isLoading && !isAuthenticated) {
      loginWithRedirect({
        appState: {
          returnTo: globalThis.location.pathname + globalThis.location.search,
        },
      });
    }
  }, [isLoading, isAuthenticated, loginWithRedirect, location]);

  if (isLoading || !isAuthenticated) {
    return <LoadingScreen />;
  }

  const principal = user?.sub
    ? JSON.stringify([config.auth0.domain, user.sub])
    : undefined;

  return (
    <ComplianceGate key={principal ?? "unknown"} principal={principal}>
      <Outlet />
    </ComplianceGate>
  );
};

export default SecureRoute;
